export default __webpack_public_path__ + "static/media/Darkblade's Boots of Supreme Decree.1fe8407d.jpg";